import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

const StyledSearchSkeleton = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
}));

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
}));

/**
 * search result details skeleton
 */
export function SearchResultsSkeleton() {
    const theme = useTheme();

    return (
        <StyledSearchSkeleton>
            <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"100%"} />

            <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"60%"} />

            <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"80%"} />
        </StyledSearchSkeleton>
    );
}

export default SearchResultsSkeleton;
